import { Link } from "react-router-dom";
import { Check, MessageCircle, ArrowUpRight, Phone } from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import { BRAND } from "../lib/site";

const STEPS = [
  "Our team reviews your enquiry personally — usually within one working day.",
  "We arrange a complimentary discovery session to understand your child.",
  "We recommend the program, cohort and journey best suited to them.",
];

export default function ThankYou() {
  return (
    <section
      data-testid="thank-you"
      className="relative min-h-screen flex items-center justify-center overflow-hidden py-32"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#141414] to-[#0a0a0a]" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full opacity-[0.10] blur-3xl gold-bg" />

      <div className="relative max-w-2xl mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <div className="mx-auto h-20 w-20 grid place-items-center rounded-full border border-[#d4af37]/50">
            <Check size={34} className="text-[#d4af37]" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 flex justify-center">
            <SectionLabel testId="thank-you-label">
              <span className="block text-center w-full">Enquiry Received</span>
            </SectionLabel>
          </div>
          <h1 className="mt-7 font-serif text-4xl sm:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            Thank you for
            <br />
            <span className="gold-text italic">reaching out.</span>
          </h1>
          <p className="mt-7 font-sans text-base lg:text-lg text-white/60 leading-relaxed">
            Your enquiry is on its way. If your mail app opened, please press send —
            and our team will personally take it from there.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 hairline p-8 text-left">
            <div className="section-label">What Happens Next</div>
            <ul className="mt-6 space-y-4">
              {STEPS.map((s, i) => (
                <li key={i} className="flex items-start gap-3 font-sans text-sm text-white/75">
                  <span className="font-serif text-lg gold-text w-7 shrink-0">0{i + 1}</span>
                  {s}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-wrap justify-center gap-5">
            <a
              href={`https://wa.me/${BRAND.whatsapp.replace(/\D/g, "")}`}
              target="_blank"
              rel="noreferrer"
              data-testid="thank-you-whatsapp"
              className="btn-gold font-sans text-[11px] tracking-[0.3em] uppercase px-9 py-5 inline-flex items-center gap-3 font-semibold"
            >
              <MessageCircle size={16} /> Chat On WhatsApp
            </a>
            <a
              href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
              data-testid="thank-you-call"
              className="font-sans text-[11px] tracking-[0.3em] uppercase px-9 py-5 border border-[#d4af37]/60 text-[#d4af37] hover:bg-[#d4af37] hover:text-black transition-all duration-500 font-semibold inline-flex items-center gap-3"
            >
              <Phone size={15} /> Call Us
            </a>
          </div>
          <Link
            to="/"
            data-testid="thank-you-home"
            className="mt-10 inline-flex items-center gap-2 font-sans text-[11px] tracking-[0.28em] uppercase text-white/50 hover:text-[#d4af37] transition-colors"
          >
            Back To Home <ArrowUpRight size={14} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
